export const SPP_VIEW = 'spp.page.landed';
export const ACCOUNT_VIEW = 'account.page.landed';
export const PAYMENT_VIEW = 'payment.page.viewed';
export const CART_VIEW = 'cart.landing.page.viewed';
export const SHIPPING_VIEW = 'shipping.page.viewed';
export const ORDER_CONFIRMATION_VIEW = 'order.confirmation.viewed';
export const HOME_PAGE_LOADED = 'home.page.loaded';
